var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfNetherlands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 9 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#21468B",
    width: 9,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 9,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#AE1C28",
    width: 9,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfNetherlands);
export default __webpack_public_path__ + "static/media/Flag_of_Netherlands.299ae45634b3bb13ffc30b233a8eb2e2.svg";
export { ForwardRef as ReactComponent };